import { useCallback, useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchProductStoreProductAction,
  setCurrentProduct,
  updateProductStoreProductAction,
} from "../slices/productStoreProductsSlice";
import { CreateProductStoreProductRequest } from "../api/createProductStoreProduct/types";
import { RootState } from "@/app/rootReducer";
import { useToast } from "@/components/ui/use-toast";

export function useProductEditPage() {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { toast } = useToast();
  const [isSubmitting, setIsSubmitting] = useState(false);

  const { currentProduct, loading } = useSelector(
    (state: RootState) => state.productStoreProducts,
  );

  useEffect(() => {
    if (id) {
      dispatch(fetchProductStoreProductAction(id));
    }

    return () => {
      dispatch(setCurrentProduct(null));
    };
  }, [dispatch, id]);

  const handleSubmit = useCallback(
    async (data: CreateProductStoreProductRequest) => {
      if (!id) return;

      setIsSubmitting(true);
      try {
        await dispatch(updateProductStoreProductAction(id, data));
        toast({
          title: "Success",
          description: "Product updated successfully",
          variant: "default",
        });
        navigate("/lead-generation/product-store/products");
      } catch {
        // Error handled by slice and global interceptor
      } finally {
        setIsSubmitting(false);
      }
    },
    [dispatch, id, navigate, toast],
  );

  return {
    currentProduct,
    loading,
    isSubmitting,
    handleSubmit,
  };
}
